import './index.css';
export default {
  name: 'input-multi-checkbox',
  props: {
    value: {
      type: [String, Number, Array, Object, Boolean],
      default: () => []
    },
    values: {
      type: Array,
      default: () => [{
        label: 'Чекбокс',
        value: 1
      }]
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },

    vAlias: {
      type: String,
      default: 'label'
    },
    vValue: {
      type: String,
      default: 'value'
    },
    error: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: null
    }
  },
  created() {
    this.$nextTick(() => {
      this.inputValue = this.$props.value;
    });
  },
  watch: {
    'inputValue'(newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal);
    },
    '$props.value'(newVal) {
      if (this.inputValue != newVal)
        this.inputValue = newVal;
    }
  },
  computed: {
    id() {
      return this._uid;
    }
  },
  methods: {}
}
